import React, { useState, useEffect } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { withTranslation } from "react-i18next";
import Card from "components/Card";
import { getStorage, setStorage } from "utils";
import constants from "../../../../constants";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import { resolveAssignedToYouOwnerId } from "hooks/useOfficeContextOfficeList";
import { STAFF_SUB_TAB } from "../tabs/constants";
import StaffOfficePolicyList from "./StaffView";
import styles from "accountOwner/pages/Notes/Notes.module.scss";

const cacheKeys = constants.officePolicies?.cache || {};

/**
 * "Assigned to you" view: staff-style card list with Current / Archived tabs.
 * Used when owner/admin selects "Assigned to you" or when staff opens the page.
 */
const AssignedToYouView = ({ t }) => {
  const { effectiveOwnerId, isOwner } = useAccountOwnerCommon();
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const cached = getStorage(cacheKeys.officePolicyStaffSub);
      return cached?.subTab ?? STAFF_SUB_TAB.currentPolicies;
    } catch {
      return STAFF_SUB_TAB.currentPolicies;
    }
  });

  useEffect(() => {
    if (cacheKeys.officePolicyStaffSub) {
      setStorage(cacheKeys.officePolicyStaffSub, { subTab: activeTab });
    }
  }, [activeTab]);

  const accountOwnerId = resolveAssignedToYouOwnerId(isOwner, effectiveOwnerId);

  return (
    <Card className={styles["assign-to-you-card"]}>
      <div className="common-tabs scheduler-tabs">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === STAFF_SUB_TAB.currentPolicies ? "active" : ""}
              onClick={() => setActiveTab(STAFF_SUB_TAB.currentPolicies)}
            >
              {t("officePolicyManagement.currentPolicies")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === STAFF_SUB_TAB.archivedPolicies ? "active" : ""}
              onClick={() => setActiveTab(STAFF_SUB_TAB.archivedPolicies)}
            >
              {t("officePolicyManagement.archivedPolicies")}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            <StaffOfficePolicyList
              isArchive={activeTab === STAFF_SUB_TAB.archivedPolicies}
              isStaff
              accountOwnerId={accountOwnerId}
            />
          </TabPane>
        </TabContent>
      </div>
    </Card>
  );
};

export default withTranslation()(AssignedToYouView);
